import StyledTooltip from './StyledTooltip';

export default StyledTooltip;
export * from './StyledTooltip';
